/** Вход по email. Регистрации нет — пользователей заводит администратор. */

import { useState } from "react";

import { ApiError, login } from "../api/client";

export function Login({ onDone }: { onDone: () => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email.trim(), password);
      onDone();
    } catch (cause: unknown) {
      setError(cause instanceof ApiError ? cause.message : "Не удалось войти.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <form className="login__box" onSubmit={submit}>
        <h1>Аналитика канала</h1>
        <p className="muted">Вход по адресу почты. Учётные записи заводит администратор.</p>
        <input
          className="input"
          type="email"
          placeholder="почта"
          value={email}
          autoComplete="username"
          onChange={(event) => setEmail(event.target.value)}
        />
        <input
          className="input"
          type="password"
          placeholder="пароль"
          value={password}
          autoComplete="current-password"
          onChange={(event) => setPassword(event.target.value)}
        />
        {error && <p className="error">{error}</p>}
        <button className="button" type="submit" disabled={busy || !email || !password}>
          {busy ? "Проверяю…" : "Войти"}
        </button>
      </form>
    </main>
  );
}
